import React, { FC } from 'react';
import { useSettings } from '@wix/tpa-settings/react';
import { classes } from './ListFilter.st.css';
import { TabsFilter } from './TabsFilter/TabsFilter';
import { TagsFilter } from './TagsFilter/TagsFilter';
import { DropdownFilter } from './DropdownFilter/DropdownFilter';
import { FilterLayoutOptions } from '../../../../../types/types';
import { DataHooks } from './consts';
import settingsParams from '../../../settingsParams';

function getFilterComponent({ layout }: { layout: FilterLayoutOptions }) {
  switch (layout) {
    case FilterLayoutOptions.DROPDOWN:
      return DropdownFilter;
    case FilterLayoutOptions.TAGS:
      return TagsFilter;
    case FilterLayoutOptions.TABS:
      return TabsFilter;
  }
}

export const ListFilter: FC = () => {
  const settings = useSettings();
  const layout = settings.get(settingsParams.filterLayout);
  const FilterComponent = getFilterComponent({ layout });
  return (
    <div data-hook={DataHooks.WRAPPER} className={classes.root}>
      <FilterComponent />
    </div>
  );
};
